// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f691f8d6","239":"6841fe53","453":"d3ebae82","455":"a76e1e6c"}[chunkId] + ".chunk.js";
};